// import { useEffect, useState } from "react";
// import { Table, Badge, Dropdown, Card } from "react-bootstrap";
// import { FaTools } from "react-icons/fa";
// import Layout from "../Components/Layout/Layout";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { userTransaction } from "../Redux/Actions/AdminActions";
// import PaginationComponent from "../Components/Layout/Pagination";
// import moment from "moment";

// const url = process.env.REACT_APP_FILE_BASE_URL;

// const getStatusBadge = (status) => {
//   switch (status) {
//     case 0:
//       return <Badge bg="warning">N/A</Badge>;
//     case 1:
//       return <Badge bg="warning">Pending</Badge>;
//     case 2:
//       return <Badge bg="success">Completd</Badge>;
//     case 3:
//       return <Badge bg="danger">Cancelled</Badge>;
//     default:
//       return <Badge bg="secondary">Pending</Badge>;
//   }
// };

// const Transactions = () => {
//   const { transactionData } = useSelector(
//     (state) => state.usermgt
//   );

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation()

//   const [page, setpage] = useState(1);
//   const [limit, setlimit] = useState(10);

//   const pageNo = new URLSearchParams(location?.search).get("page") || page;

//   const [flag, setflag] = useState(true);
//   const [filter, setFilter] = useState("0");

//   const handlePageChange = (pageNumber) => {
//     setpage(pageNumber);
//     navigate(`/transaction?page=${pageNumber}`)
//   };

//   useEffect(() => {
//     const searchData = {
//       page: pageNo,
//       limit: limit,
//     };
//     dispatch(userTransaction(searchData));
//   }, [pageNo, limit, flag, dispatch, filter]);

//   return (
//     <Layout> 
//       <div className="filters">
//         <div className="inner-filter-field">
//           <Card className="transaction-card">
//             <Card.Header className="transaction-header p-3">
//               <FaTools className="me-2" />
//               <h5 className="mb-0">Bookings</h5>
//             </Card.Header>
//             <Card.Body>
//               <Table responsive hover bordered className="transaction-table">
//                 <thead>
//                   <tr>
//                     <th>S.No</th>
//                     <th>Username</th>
//                     <th>Booked Service</th>
//                     <th>Transaction ID</th>
//                     <th>Date & Time</th>
//                     <th>Base Fare</th>
//                     <th>Payment Status</th>
//                     <th>View</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {!transactionData?.transaction?.length ? null : transactionData?.transaction.map((txn, index) => (
//                     <tr key={txn.id}>
//                       <td>{(index + (pageNo - 1) * limit) + 1}</td>
//                       <td>{txn?.user_id?.name}</td>
//                       <td>{txn?.request_id?.serviceId?.service_name || 'N/A'}</td>
//                       <td>{txn.transaction_id}</td>
//                       <td>{moment(txn?.createdAt).format("DD/MM/YYYY HH:mm") || "N/A"}</td>
//                       <td>{txn?.total_amount ? `$` + txn?.total_amount : 'N/A'}</td>
//                       <td>{getStatusBadge(txn.payment_status)}</td>
//                       <td>
//                         {/* <Dropdown
//                           className={txn.status === "On Hold" ? "drop" : ""}
//                         >
//                           <Dropdown.Toggle variant="secondary" size="sm">
//                             Action
//                           </Dropdown.Toggle>
//                           <Dropdown.Menu className="view-details-main">
//                             <Dropdown.Item>View Details</Dropdown.Item>
//                             {txn.status === "On Hold" && (
//                               <Dropdown.Item>Confirm Payment</Dropdown.Item>
//                             )}
//                             <Dropdown.Item>Cancel Transaction</Dropdown.Item>
//                           </Dropdown.Menu>
//                         </Dropdown> */}
//                         <Link
//                           to={`/transaction/${txn?.request_id?._id}`}
//                         >

//                           <img
//                             src={
//                               require("../Assets/Images/view-icon.svg")
//                                 .default
//                             }
//                           />
//                         </Link>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//               <div className="pagination-section">
//                 <div className="showing-user">
//                   <p>
//                     Showing {1 + (pageNo - 1) * limit} -
//                     {Math.min(pageNo * limit, transactionData?.totalCount)}{" "}
//                     of {transactionData?.totalCount} results
//                   </p>
//                 </div>
//                 <div className="pagination-block">
//                   <PaginationComponent
//                     currentPage={pageNo}
//                     totalCount={transactionData?.totalCount}
//                     limit={transactionData?.totalPages}
//                     onPageChange={handlePageChange}
//                   />
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default Transactions;



import { useEffect, useState } from "react";
import { Table, Badge, Card, Tabs, Tab, Form } from "react-bootstrap";
import { FaTools } from "react-icons/fa";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { userTransaction, unAcceptedBookings } from "../Redux/Actions/AdminActions";
import PaginationComponent from "../Components/Layout/Pagination";
import moment from "moment";

const url = process.env.REACT_APP_FILE_BASE_URL;

const getStatusBadge = (status) => {
  switch (status) {
    case 0:
      return <Badge bg="warning">N/A</Badge>;
    case 1:
      return <Badge bg="warning">Pending</Badge>;
    case 2:
      return <Badge bg="success">Completed</Badge>;
    case 3:
      return <Badge bg="danger">Cancelled</Badge>;
    default:
      return <Badge bg="secondary">Pending</Badge>;
  }
};

const Transactions = () => {
  const { transactionData, unAcceptedBookingData } = useSelector(
    (state) => state.usermgt
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [activeTab, setActiveTab] = useState("bookings");
  const [statusFilter, setStatusFilter] = useState("");

  const pageNo = Number(new URLSearchParams(location?.search).get("page")) || page;

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    navigate(`?page=${pageNumber}`);
  };

  useEffect(() => {
    const searchData = { page: pageNo, limit };
    if (activeTab === "bookings") {
      if (statusFilter) searchData.filter = Number(statusFilter);
      dispatch(userTransaction(searchData));
    } else {
      dispatch(unAcceptedBookings(searchData));
    }
  }, [pageNo, limit, activeTab, statusFilter, dispatch]);


  return (
    <Layout>
      <div className="filters">
        <div className="inner-filter-field">
          <Card className="transaction-card">
            <Card.Header className="transaction-header p-3 d-flex align-items-center">
              <FaTools className="me-2" />
              <h5 className="mb-0">Bookings</h5>
            </Card.Header>
            <Card.Body>
              <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>

                <Tab eventKey="bookings" title="Bookings">
                  <div className="d-flex justify-content-end m-2">
                    <Form.Select
                      value={statusFilter}
                      onChange={(e) => {
                        setPage(1);
                        navigate(`?page=1`);
                        setStatusFilter(e.target.value);
                      }}
                      style={{ width: "200px" }}
                    >
                      <option value="">All</option>
                      <option value={1}>Pending</option>
                      <option value={2}>Completed</option>
                      <option value={3}>Cancelled</option>
                    </Form.Select>

                  </div>

                  <Table responsive hover bordered className="transaction-table mt-3">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Username</th>
                        <th>Booked Service</th>
                        <th>Transaction ID</th>
                        <th>Date & Time</th>
                        <th>Base Fare</th>
                        <th>Payment Status</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!transactionData?.transaction?.length ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      ) : (
                        transactionData.transaction.map((txn, index) => (
                          <tr key={txn.id}>
                            <td>{(index + (pageNo - 1) * limit) + 1}</td>
                            <td>{txn?.user_id?.name}</td>
                            <td>
                              {txn?.request_id?.serviceId?.service_name || "N/A"}
                            </td>
                            <td>{txn.transaction_id}</td>
                            <td>
                              {moment(txn?.createdAt).format("DD/MM/YYYY HH:mm") ||
                                "N/A"}
                            </td>
                            <td>
                              {txn?.total_amount ? `$${txn?.total_amount?.toFixed(2)}` : "N/A"}
                            </td>
                            <td>{getStatusBadge(txn.payment_status)}</td>
                            <td>
                              <Link to={`/transaction/${txn?.request_id?._id}`}>
                                <img
                                  src={require("../Assets/Images/view-icon.svg").default}
                                  alt="View"
                                />
                              </Link>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>

                  {transactionData?.totalCount > 0 && (
                    <div className="pagination-section">
                      <div className="showing-user">
                        <p>
                          Showing {1 + (pageNo - 1) * limit} -
                          {Math.min(pageNo * limit, transactionData?.totalCount)}{" "}
                          of {transactionData?.totalCount} results
                        </p>
                      </div>
                      <div className="pagination-block">
                        <PaginationComponent
                          currentPage={pageNo}
                          totalCount={transactionData?.totalCount}
                          limit={limit}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </Tab>

                {/* Unaccepted Bookings Tab */}
                <Tab eventKey="unaccepted" title="Unaccepted Bookings">
                  <Table
                    responsive
                    hover
                    bordered
                    className="transaction-table mt-3"
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Username</th>
                        <th>Booked Service</th>
                        <th>Location</th>
                        <th>Date & Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!unAcceptedBookingData?.transaction?.length ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      ) : (
                        unAcceptedBookingData.transaction.map((txn, index) => (
                          <tr key={txn.id}>
                            <td>{(index + (pageNo - 1) * limit) + 1}</td>
                            <td>{txn?.userId?.name}</td>
                            <td>{txn?.serviceId?.service_name || "N/A"}</td>
                            <td>{txn?.pickUpAddress || "N/A"}</td>
                            <td>
                              {moment(txn?.createdAt).format("DD/MM/YYYY HH:mm") ||
                                "N/A"}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>

                  {unAcceptedBookingData?.totalCount > 0 && (
                    <div className="pagination-section">
                      <div className="showing-user">
                        <p>
                          Showing {1 + (pageNo - 1) * limit} -
                          {Math.min(pageNo * limit, unAcceptedBookingData?.totalCount)}{" "}
                          of {unAcceptedBookingData?.totalCount} results
                        </p>
                      </div>
                      <div className="pagination-block">
                        <PaginationComponent
                          currentPage={pageNo}
                          totalCount={unAcceptedBookingData?.totalCount}
                          // limit={unAcceptedBookingData?.totalPages}
                          limit={limit}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default Transactions;

